import { initModalImages } from './modals/initModalImages';
import { initRatingModal } from './modals/initRatingModal';

export const initModals = (initRating) => {
    initModalImages();
    initRatingModal(initRating);
};
